export default "__VITE_ASSET__6f80f7e8__"